<div *ngIf="!isRequestSucceeded && !isRestudySucceeded">
  <h2 class="sectionTitle">Economic Committee - Formulated Approved Decision</h2>
  <!-- Rebate Request - Display Mode -->
  <app-rebate-request #rebateRequest (rebateRequestLoadedFlag)="onRebateRequestLoadedFlag($event)"></app-rebate-request>
  <div [class.read-only-content]="isRequestHistoryComponent" class="form-container">
    <div class="form-section">
      <h4 class="section-title">Formulated Approved Rebate Decision</h4>
      <!-- Date -->
      <div class="form-group">
          <label for="lblDate">Date</label>
          <label class="form-control" name="Date" id="lblDate">{{longHaulRequestFormulateDecisionResponse.CurrentDate}}</label>
      </div>
      <!-- Requester -->
      <div class="form-group">
          <label for="lblDate">Registered User (Requester) Name</label>
          <label class="form-control" name="Date" id="lblDate">{{rebateRequest.rebateRequestLoaded.RequestorEmail}}</label>
      </div>
      <!-- Rebate File No. -->
      <div class="form-group">
          <label for="lblDate">Rebate File no.</label>
          <label class="form-control" name="Date" id="lblDate">{{rebateRequest.rebateRequestLoaded.RebateFileNumber}}</label>
      </div>
      <!-- Vessel Name -->
      <div class="form-group">
          <label for="lblDate">Vessel Name</label>
          <label class="form-control" name="Date" id="lblDate">{{rebateRequest.rebateRequestLoaded.VesselName}}</label>
      </div>
    </div>
    <!-- Long Haul Request Option(s) Section -->
    <div class="form-section">
      <h4 class="section-title">Rebate Request Option(s)</h4>
      <!-- Long Haul Request Option(s) -->
      <div class="form-group">
        <label for="ddlOptions">Options</label>
          <select [(ngModel)]="currentSelctedOption" class="form-control" id="ddlOptions" name="Options" (change)="onOptionChange($event)">
            <option [value]="null" selected>Choose</option>
            <option *ngFor="let longHaulRequestOption of longHaulRequestFormulateDecisionResponse.LongHaulRequestOptionsFormulatedDecision; let i = index;" [value]="longHaulRequestOption?.Id">
              Option {{i + 1}} ({{longHaulRequestOption.LastPortOfOrigin}} - {{longHaulRequestOption.FirstPortOfDestination}})
            </option>
          </select>
      </div>
    </div>
    <!-- Long Haul Request Option Details -->
    <div class="form-container" *ngIf="isOptionDetailsSelected" >
      <h4 class="section-title">
        {{optionSelectedText}} Details
      </h4>
    </div>
    <div [class.read-only-content]="!isRequestHistoryComponent" *ngIf="isOptionDetailsSelected">
      <fieldset [disabled]="true">
        <div class="form-section">
          <h4 class="section-title">Voyage Information</h4>
          <!-- From -->
          <div class="form-group">
            <label for="lblFrom">From</label>
            <label class="form-control" disabled="disabled" name="From" id="lblFrom">{{selectedLongHaulRequestOption.LastPortOfOrigin}}</label>
          </div>
          <!-- To -->
          <div class="form-group">
            <label for="lblTo">To</label>
            <label class="form-control" disabled="disabled" name="To" id="lblTo">{{selectedLongHaulRequestOption.FirstPortOfDestination}}</label>
          </div>
          <!-- Rebate Percentage Numbers -->
          <div class="form-group">
            <label for="lblRebatePercentageNumbers">Rebate Percentage in Numbers</label>
            <label class="form-control" disabled="disabled" name="RebatePercentageNumbers" id="lblRebatePercentageNumbers">{{selectedLongHaulRequestOption.RebatePercentage}}</label>
          </div>
          <!-- Rebate Percentage Leters -->
          <div class="form-group">
            <label for="lblRebatePercentageLetters">Rebate Percentage in Letters</label>
            <label class="form-control" disabled="disabled" name="RebatePercentageLetters" id="lblRebatePercentageLetters">{{selectedLongHaulRequestOption.RebatePercentageLetters}}</label>
          </div>
          <!-- Economic Committee Notes -->
          <div class="form-group">
            <label for="lblRebatePercentageLetters">Economic Committee Notes</label>
            <textarea class="form-control" disabled="disabled" name="EconomicCommitteeNotes" id="lblEconomicCommitteeNotes">{{selectedLongHaulRequestOption.EconomicCommitteeNotes}}</textarea>
          </div>
        </div>
      </fieldset>
    </div>
    <!-- Formulated Approved Decision -->
    <div class="form-section">
      <h4 class="section-title">Formulated Approved Decision</h4>
      <form name="form" #f="ngForm" style="width:100%;">
        <!-- Formulated Decision -->
        <div class="form-group">
          <label for="txtFormulatedDecision">Formulated Decision</label>
          <span class="red"> *</span>
          <textarea [(ngModel)]="longHaulRequestFormulateDecisionResponse.FormulatedDecision" [disabled]="isRequestHistoryComponent" name="FormulatedDecision" id="txtFormulatedDecision" class="form-control" #FormulatedDecision="ngModel" required></textarea>
          <div *ngIf="isFormSubmitted && FormulatedDecision?.invalid" class="red">
            <span *ngIf="FormulatedDecision?.errors?.required">This Field is Required</span>
          </div>
        </div>
      </form>
    </div>
    <div *ngIf="!isRequestHistoryComponent" class="form-group">
      <button type="button" class="btn SCAcustomBtn" Confirmation (confirmationClick)="isFormSubmitted = true; f.form.valid && submit()">Submit</button>
      <button type="button" class="btn SCAcustomBtn" (click)="later()">Later</button>
    </div>

    <div *ngIf="!isRequestHistoryComponent" class="form-group">

      <button type="button" class="btn SCAcustomBtn" Confirmation (confirmationClick)="isFormSubmitted = true; f.form.valid && Restudy()">Restudy</button>
    </div>
  </div>
</div>
<!-- Confirmation -->
<div *ngIf="isRequestSucceeded && submitConfirmationMode == 1" class="alert alert-success" role="alert">
  <div class="alignC">
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g>
        <g>
          <path d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z"></path>
        </g>
      </g>
    </svg>
    <p>You have submitted Rebate Request Formulated Approved Decision</p>
    <p>Go Back to <a routerLink="/myTasks">My Tasks</a></p>
  </div>
</div>
<div *ngIf="isRestudySucceeded && submitConfirmationMode == 1" class="alert alert-success" role="alert">
  <div class="alignC">
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g>
        <g>
          <path d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z"></path>
        </g>
      </g>
    </svg>
    <p>You have submitted this Rebate Request to be Restudied</p>
    <p>Go Back to <a routerLink="/myTasks">My Tasks</a></p>
  </div>
</div>
<!-- Warning -->
<div *ngIf="isRequestSucceeded && submitConfirmationMode == 2" class="alert alert-warning" role="alert">
  <div class="alignC">
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g>
        <g>
          <path d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z"></path>
        </g>
      </g>
    </svg>
    <p>This task was submitted before</p>
    <p>Go Back to <a routerLink="/myTasks">My Tasks</a></p>
  </div>
</div>
<!-- Error -->
<div *ngIf="isRequestSucceeded && submitConfirmationMode == 3" class="alert alert-danger" role="alert">
  <div class="alignC">
      <i class="icon-error"></i>
      <p>Something went wrong, Please contact System Administrator</p>
      <hr>
      <p>Go Back to <a routerLink="/workspace">Workspace</a></p>
  </div>
</div>
